import AmiStrings from '../strings.js';

export default function AmiUsersSidebar() {
    var sbName = 'userList';
    var body = <div />;

    var setTitle;

    return {
        getName: function() { return sbName; },
        isWide: function() { return false; },
        getBody: function() { return body; },
        apply: function(obj) {
            setTitle = obj.setTitle;
        },
        reloadStrings: function() {
            setTitle(AmiStrings.getMenuString('online'));
        },
    };
};
